import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { CommissionType } from "@/lib/commission-catalog.api";
import {
  ALL_TYPE_FILTER_VALUE,
  type CommissionViewMode,
} from "../commission.constants";
import { CommissionViewToggle } from "./CommissionViewToggle";

interface CommissionsToolbarProps {
  search: string;
  typeFilter: string;
  viewMode: CommissionViewMode;
  types: CommissionType[];
  filteredCount: number;
  onSearchChange: (value: string) => void;
  onTypeFilterChange: (value: string) => void;
  onViewModeChange: (mode: CommissionViewMode) => void;
}

export function CommissionsToolbar({
  search,
  typeFilter,
  viewMode,
  types,
  filteredCount,
  onSearchChange,
  onTypeFilterChange,
  onViewModeChange,
}: CommissionsToolbarProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 border-y border-border py-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-1 flex-col gap-2 sm:flex-row">
        <div className="relative max-w-xs flex-1">
          <Search
            size={13}
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-subtle"
          />
          <Input
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Rechercher une commission..."
            className="pl-8"
          />
        </div>
        <Select
          value={typeFilter || ALL_TYPE_FILTER_VALUE}
          onValueChange={(value) =>
            onTypeFilterChange(value === ALL_TYPE_FILTER_VALUE ? "" : value)
          }
        >
          <SelectTrigger className="w-52">
            <SelectValue placeholder="Tous les types" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL_TYPE_FILTER_VALUE}>Tous les types</SelectItem>
            {types.map((type) => (
              <SelectItem key={type.code} value={type.code}>
                {type.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center justify-between gap-3">
        <p className="text-[11.5px] text-muted-foreground">
          {filteredCount} résultat{filteredCount !== 1 ? "s" : ""}
        </p>
        <CommissionViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
      </div>
    </div>
  );
}
